// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"3b2d0b26","513":"30b321bd","787":"3c6832f4"}[chunkId] + ".chunk.js";
};